
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useTimeSlotRealtime = (serviceId?: string, date?: Date) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!serviceId || !date) return;

    console.log('Setting up real-time subscription for time slots:', { serviceId, date: date.toISOString() });

    const channel = supabase
      .channel('time_slots_changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'time_slots',
          filter: `service_id=eq.${serviceId}`
        },
        (payload) => {
          console.log('Time slot real-time update received:', payload);
          
          // Invalidate relevant queries to trigger refetch
          queryClient.invalidateQueries({ 
            queryKey: ['available-time-slots', serviceId, date.toISOString()] 
          });
          queryClient.invalidateQueries({ 
            queryKey: ['time-slots', undefined, serviceId] 
          });
        }
      )
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'bookings'
        },
        (payload) => {
          console.log('Booking real-time update received:', payload);
          
          // Invalidate time slot queries when any booking changes
          // The trigger will automatically update time slot counts
          queryClient.invalidateQueries({ 
            queryKey: ['available-time-slots', serviceId, date.toISOString()] 
          });
          queryClient.invalidateQueries({ 
            queryKey: ['provider-bookings'] 
          });
        }
      )
      .subscribe();

    return () => {
      console.log('Cleaning up real-time subscription');
      supabase.removeChannel(channel);
    };
  }, [serviceId, date, queryClient]);
};
